exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n::-webkit-scrollbar {\n\t-webkit-appearance: none;\n\twidth: 8px;\n\theight: 8px;\n}\n::-webkit-scrollbar-track {\n\tbackground: rgba(0, 0, 0, 0.1);\n\tborder-radius: 0;\n}\n::-webkit-scrollbar-thumb {\n\tcursor: pointer;\n\tborder-radius: 5px;\n\tbackground: #659aff;\n\t-webkit-transition: color 0.2s ease;\n\ttransition: color 0.2s ease;\n}\n::-webkit-scrollbar-thumb:hover {\n\tbackground: rgba(0, 0, 0, 0.3);\n}\n", ""]);

// exports
